import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

function ProtectedRoute({ children }) {
    const { user, isAdmin } = useAuth()
    const location = useLocation()

    if (!user || !isAdmin) {
        return <Navigate to="/admin/login" state={{ from: location }} replace />
    }

    return children
}

export default ProtectedRoute 